import React, { Component } from "react";
import PropTypes from "prop-types";
import debounce from "lodash/debounce";

class InputDebounced extends Component {
  constructor(props) {
    super(props);

    const { debounceRate = 300 } = props;

    this.debouncedSearch = debounce(this.handleChange, debounceRate);
  }

  handleChange(e) {
    const { onChange } = this.props;
    e.preventDefault();
    onChange(e);
  }

  render() {
    const { className, placeholder, type, inputRef, disabled } = this.props;

    const maybeRef = inputRef ? inputRef : null;

    return (
      <input
        data-testid="t-InputDe-input"
        className={className}
        onChange={(e) => this.debouncedSearch(e)}
        type={type}
        placeholder={placeholder}
        ref={maybeRef}
        aria-label={this.props["aria-label"]}
        disabled={disabled}
      />
    );
  }
}

InputDebounced.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  debounceRate: PropTypes.number,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  ref: PropTypes.func,
  disabled: PropTypes.bool,
  "aria-label": PropTypes.string,
};

export default InputDebounced;
